import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col col-12" }
const _hoisted_2 = { class: "row py-3 g-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-12 pe-lg-2 px-4 col-md-12 g-0" }, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0 mt-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "mb-1",
  for: "contact_relationship"
}, [
  /*#__PURE__*/_createElementVNode("b", null, " Evacuation Zone ")
], -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Zone", -1 /* HOISTED */)
const _hoisted_7 = ["value"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1 mt-3" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Evacuation Address")
], -1 /* HOISTED */)
const _hoisted_9 = { class: "w-100 pb-2" }
const _hoisted_10 = { class: "form-check custom-checkbox" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "contact-address"
}, " Same as Emergency Contact ", -1 /* HOISTED */)
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "row col-12" }
const _hoisted_14 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "contact-mobile-number" }, " Mobile Phone ", -1 /* HOISTED */)
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-group col-12 col-lg-6 pe-lg-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "contact-alternate-mobile" }, " Alternate Phone ", -1 /* HOISTED */)
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "w-100" }
const _hoisted_21 = { class: "form-check custom-checkbox" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "as-visit-location"
}, " Set as visit location ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReferralAddressForm = _resolveComponent("ReferralAddressForm")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Evacuation",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              class: "form-select me-2",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.EmergencyPreparedness.EvacuationZone) = $event))
            }, [
              _hoisted_6,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zones, (zone, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: index,
                  value: zone.value
                }, _toDisplayString(zone.name), 9 /* TEXT, PROPS */, _hoisted_7))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.referral.EmergencyPreparedness.EvacuationZone]
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "contact-address",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SameAsEmergencyContactEvacChanged())),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.EmergencyPreparedness.SameAsEmergencyContactEvac) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.EmergencyPreparedness.SameAsEmergencyContactEvac]
                ]),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_ReferralAddressForm, {
                address: _ctx.referral.EmergencyPreparedness.EvacuationAddress,
                "address-type": 'evacuation',
                "show-code": false,
                "show-zip-four-code": false,
                "state-class": _ctx.stateClass,
                countyData: _ctx.EvacuationCounty,
                zipChanged: _ctx.getCounty
              }, null, 8 /* PROPS */, ["address", "state-class", "countyData", "zipChanged"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _withDirectives(_createElementVNode("input", {
                  id: "contact-mobile-number",
                  type: "text",
                  value: _ctx.formatPhone(_ctx.referral.EmergencyPreparedness.EvacuationPhoneMobile),
                  class: "form-control phone-number-input",
                  maxlength: "14",
                  placeholder: "Enter Number",
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setMobilePhone($event.target.value)))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_16), [
                  [_directive_number_only]
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  id: "contact-alternate-mobile",
                  type: "text",
                  value: _ctx.formatPhone(_ctx.referral.EmergencyPreparedness.EvacuationPhoneHome),
                  class: "form-control phone-number-input",
                  maxlength: "14",
                  placeholder: "Enter Number",
                  onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAlternatePhone($event.target.value)))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_19), [
                  [_directive_number_only]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "form-check-input",
                  id: "as-visit-location",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.EmergencyPreparedness.SetAsVisitLocation) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.EmergencyPreparedness.SetAsVisitLocation]
                ]),
                _hoisted_22
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}